<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form class="form-horizontal">
        <div class="box box-info" >
        <div class="p-toolbar p-component mb-4">
              <Button  class="p-button p-component p-button-success addNewBtn btn-btm-0" label="NEW"  @click.prevent="openBasic" icon="pi pi-plus"/>
            </div>
        </div>
        <Dialog header="Role" :visible.sync="displayModal"
                :style="{width: '50vw'}" :modal="true" :closable="false">

          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="name">Name</label>
              <InputText v-model.trim="name" id="name"/>
            </div>
            <div class="p-field p-col-12 p-md-6"></div>
            <div class="p-field p-col-12 p-md-6">
              <Accordion v-for="(module,ind) in moduleList" :key="ind">
                <!-- <Checkbox @change="onChange(module.moduleList, selectValue,ind)" v-model="selectValue" :binary="true"> </Checkbox> -->
                <AccordionTab :header="module.moduleName">
                  <Checkbox @change="onChange(module.moduleList, selectValue)" v-model="selectValue" :binary="true"> </Checkbox>
                  <label for="role" style="margin-left: 10px;">All</label>
                  <div v-for="(role,inx) in module.moduleList" :key="inx">
                    <Checkbox v-model="moduleChecked" id="role" :value="role.roleId"/>
                    <label for="role" style="margin-left: 10px;">{{ role.roleName }}</label>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised"
                    @click.prevent="addRole" :label="!editing?'Add':'Update'"/>
            <Button class="p-button-raised p-button-info"
                    @click.prevent="addAndNewRole" v-if="!editing"
                    label="Add & New"/>
            <Button class="p-button-raised p-button-danger"
                    @click.prevent="cancel" label="Cancel"/>
          </template>
        </Dialog>
      </form>
      <roleList @delete-message="deleteMessage" @edit-role="editRole"/>
    </div>

  </section>
</template>
<script>
import roleList from './roleList.vue'
import Dialog from 'primevue/dialog'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'

export default {
  name: 'role',
  data() {
    return {
      name: '',
      editing: false,
      displayModal: false,
      id: '',
      moduleList: [],
      loading: false,
      moduleChecked: [],
      selectedChecked: [],
      selectValue: false
    }
  },
  computed: {},
  created() {
    this.modules()
  },
  methods: {
    async modules() {
      let resp = await this.$store.dispatch('moduleList')
      this.moduleList = resp.data.data
      console.log(resp.data.data)
    },
    async addRole() {
      let resp = ''
      if (this.name.trim() === '' || this.moduleChecked === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Data cannot be empty!', life: 10000})
        return
      }
      let role = {
        name: this.name,
        id: this.id,
        moduleList: [
          {
            roleId: this.moduleChecked.toString()
          }
        ]
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createRole', role)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateRole', role)
        this.loading = false
      }
      this.responseMessage(resp)
      this.displayModal = !this.displayModal
    },
    async addAndNewRole() {
      let resp = ''
      if (this.name.trim() === '' || this.moduleChecked === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Data cannot be empty!', life: 10000})
        return
      }
      let role = {
        name: this.name,
        id: this.id,
        moduleList: [
          {
            roleId: this.moduleChecked.toString()
          }
        ]
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createRole', role)
      this.loading = false
      this.responseMessage(resp)
    },
    onChange(modulesId, selectValue) {
      console.log(modulesId, selectValue, this.moduleChecked)
      if (selectValue === true && !modulesId.includes(this.moduleChecked.roleId)) {
        modulesId.forEach(mod => this.moduleChecked.push(mod.roleId))
        console.log('true ')
      }
      // else {
      //   modulesId.forEach(mod => this.moduleChecked.splice(mod.roleId))
      //   console.log('false ma')
      // }
      console.log(this.moduleChecked, selectValue)
      // if (modulesId.includes(this.moduleChecked.roleId )) {
      //   this.selectValue = false
      // }
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    openBasic() {
      this.displayModal = true
    },
    closeBasic() {
      this.displayModal = false
    },
    setTimeInterval() {
      setTimeout(() => {
        this.show = false
      }, 3000)
    },
    deleteMessage(value) {
      this.message = value
      this.messageType = 'alert-Danger'
      this.show = true
      this.setTimeInterval()
      this.closeBasic()
    },
    editRole(data) {
      this.editing = true
      this.name = data.name
      if (data.modules.length > 0) {
        this.moduleChecked = data.modules.split(',')
      }
      this.id = data.id
      this.openBasic()
    },
    cancel() {
      this.editing = false
      this.reset()
      this.closeBasic()
    },
    reset() {
      this.name = ''
      this.moduleChecked = []
    }
  },
  components: {
    roleList,
    Dialog,
    Accordion,
    AccordionTab,
    Checkbox,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// role.vue?0831c0ee